import { StyledAdminList } from './styles';
interface IAdminListProps {
  children?: React.ReactNode;
  renderControls: () => React.ReactNode;
  renderPaginator?: () => React.ReactNode;
}
export const AdminList = ({ children, renderControls, renderPaginator }: IAdminListProps) => {
  return (
    <StyledAdminList>
      <header className="admin-list-header">
        <div className="admin-list-header__controls">{renderControls()}</div>
      </header>
      <div className="admin-list-body">{children}</div>
      <footer className="admin-list-footer">{renderPaginator?.()}</footer>
    </StyledAdminList>
  );
};
